/** Regelversion 2: Gesetze zu den Meinungsthemen, auch ohne passendes Problem auf der Liste. */
import { useState } from 'react';
import { useGame, useS } from '../../store/game';
import { Panel, Tag } from '../../components/ui';
import { AXN, QS } from '../../content/axes';
import { capOf } from '../../engine/adm';
import { pub, scaleLabel } from '../../engine/opinion';
import { agendaFor } from '../../engine/v2';
import { busyOf, canDraft, coopGov } from '../../engine/coalition';
import { since } from '../../engine/version';
import { TrendNote } from '../../components/Trend';
import { axes as axesNow } from '../../engine/axes';

const SHOW = 6;

export function Agenda() {
  const S = useS(); const { dispatch } = useGame();
  const [all, setAll] = useState(false);
  if (!since(2)) return null;
  const busy = busyOf('YOU'), cap = capOf('YOU'), full = busy >= cap;
  // Themen, bei denen die Bevölkerung eine klare Meinung hat, zuerst
  const axList = [...axesNow()].sort((a, b) => Math.abs(pub(b)) - Math.abs(pub(a)));
  const list = all ? axList : axList.slice(0, SHOW);
  return (
    <Panel title="Vorhaben aus den Meinungsthemen" aside="Stimmung im Land" className="agenda">
      <p className="sub">Hier kannst du Gesetze zu den Themen anstoßen, über die das Land gerade streitet, auch wenn sie nicht als Problem auf der Liste stehen. Gesetze, die zur Mehrheitsmeinung passen, bringen beim Inkrafttreten Zustimmung. Gesetze gegen die Mehrheit kosten welche.</p>
      <div className="aglist">{list.map((a) => { const pv = pub(a), you = S.you[a] ?? 0, items = agendaFor(a); return (
        <div className="agrow" key={a}>
          <div className="aghead"><b>{AXN[a]}</b><span className="sub">{QS[a]}</span></div>
          <div className="tags"><Tag>Bevölkerung: {scaleLabel(pv)}</Tag><Tag>Euer Programm: {scaleLabel(you)}</Tag></div>
          <TrendNote a={a} y={you} />
          <div className="agacts">{items.map((x) => { const mine = !coopGov() || canDraft('YOU', x.T), pro = x.dir > 0, popular = pro === pv > 0 && Math.abs(pv) >= .5;
            return <button type="button" key={x.i} className="small" disabled={x.busy || x.done || full || !mine} title={x.done ? 'Dieses Gesetz gilt bereits.' : x.busy ? 'Zu diesem Thema läuft schon ein Gesetz.' : !mine ? 'Das zuständige Ministerium führt der Koalitionspartner.' : full ? `Höchstens ${cap} Vorhaben gleichzeitig.` : undefined}
              onClick={() => dispatch('draftAgenda', a, x.i)}>{x.it.label ?? x.T.t}<span className={'agdir ' + (popular ? 'up' : Math.abs(pv) >= .5 ? 'down' : '')}>{pro ? 'dafür' : 'dagegen'}</span>{x.done ? <span className="sub"> · gilt</span> : x.busy && <span className="sub"> · läuft</span>}</button>; })}</div>
        </div>); })}</div>
      <button type="button" className="linkb" onClick={() => setAll(!all)}>{all ? 'Weniger Themen zeigen' : `Alle ${axList.length} Themen zeigen`}</button>
      {full && <span className="sub">Eure Ministerien arbeiten an {cap} Vorhaben gleichzeitig. Mehr geht erst, wenn eines abgeschlossen ist.</span>}
    </Panel>
  );
}
